module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/clientes/detalles/clientes-detalles.component.scss
// module id = ./src/app/clientes/detalles/clientes-detalles.component.scss
// module chunks = main